const escapeMap: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

// Todo dato escrito polo usuario ten que pasar por aquí antes de ir ao HTML do correo
export const escapeHtml = (value: string): string => value.replace(/[&<>"']/g, char => escapeMap[char])

const LOGO_URL = 'https://lechuzascelestes.com/wp-content/uploads/2024/10/cropped-logo.png'

const socialLink = (href: string, icon: string, alt: string): string => `
        <a href="${href}" target="_blank" style="text-decoration: none; margin: 0 5px;">
            <img src="${icon}" alt="${alt}" width="32" height="32" style="vertical-align: middle;">
        </a>`

export const emailLayout = (title: string, content: string): string => `<!DOCTYPE html>
<html lang="gl">
<head>
    <meta charset="UTF-8">
    <title>${escapeHtml(title)}</title>
    <style>
        body { font-family: Arial, sans-serif; margin: 0; padding: 0; line-height: 1.6; }
        .container { max-width: 600px; margin: 20px auto; background-color: #ffffff; padding: 20px; border-radius: 10px; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); }
        h1, p { margin: 10px 0; }
        a { color: #4299e1; }
        .logo { text-align: center; }
        .logo img { max-width: 350px; }
        .user-data { padding: 10px; border: 1px solid #ccc; border-radius: 5px; background-color: #f9f9f9; }
        .footer { background-color: #4299e1; color: #ffffff; text-align: center; padding: 10px; border-radius: 0 0 10px 10px; }
    </style>
</head>
<body>
<div class="container">
    <div class="logo">
        <img src="${LOGO_URL}" alt="Lechuzas Celestes">
    </div>
    <div class="content">
        ${content}
    </div>
    <div class="footer">
        <img src="${LOGO_URL}" alt="Lechuzas Celestes" style="max-width: 150px">
        <br>
        <p style="margin: 15px 0 5px 0; font-size: 14px;">Síguenos nas redes:</p>${
          socialLink('https://www.facebook.com/lechuzas.celestes.1', 'https://cdn-icons-png.flaticon.com/512/733/733547.png', 'Facebook')
        }${
          socialLink('https://x.com/le_chuzas', 'https://cdn-icons-png.flaticon.com/512/5968/5968830.png', 'X (Twitter)')
        }${
          socialLink('https://www.instagram.com/lechuzascelestes/', 'https://cdn-icons-png.flaticon.com/512/2111/2111463.png', 'Instagram')
        }
    </div>
</div>
</body>
</html>`
